module.exports = __webpack_public_path__ + "img/BGMain6.91f6d6eb.jpg";